import { poNumberFormate } from "jsFunctions/helperFunctions";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { poMonthFormate } from "jsFunctions/helperFunctions";

export const getGstExcelData = (tdsList) => {
    let list = JSON.parse(JSON.stringify(tdsList));
    const exportData = list.map((data, index) => {
      let content = {
        no: index + 1,
        "Order PO Number": data.poNo && poNumberFormate(data.poNo),
       
        "Current Order Month": data.oM && poMonthFormate(data.oM),
        "Company Name":  data?.gstFields?.companyName,
        "Company GST Number":  data?.gstFields?.gstNumber,
        "Base Amount":  `₹ ${data?.gstFields?.baseAmount  ? formatAmountIndianRupees(data?.gstFields?.baseAmount ) : Number(0).toFixed(2)}`,
        "IGST Amount": `₹ ${data?.gstFields?.gstAmount?.i  ? formatAmountIndianRupees(data?.gstFields?.gstAmount?.i) : Number(0).toFixed(2)}`,
        "SGTS Amount": `₹ ${data?.gstFields?.gstAmount?.s  ? formatAmountIndianRupees(data?.gstFields?.gstAmount?.s) : Number(0).toFixed(2)}`,
        "CGST Amount": `₹ ${data?.gstFields?.gstAmount?.c  ? formatAmountIndianRupees(data?.gstFields?.gstAmount?.c) : Number(0).toFixed(2)}`,
        "Total GST Amount": `₹ ${data?.gstFields?.totalGst  ? formatAmountIndianRupees(data?.gstFields?.totalGst) : Number(0).toFixed(2)}`,
      };

      return content;
    });
    return exportData;
  };